/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';

	// 「もっと読む」ボタンの処理
	const initReadMoreButton = () => {
		const readMoreBtns = document.querySelectorAll('.js-history-lead-btn');

		readMoreBtns.forEach(btn => {
			btn.addEventListener('click', (e) => {
				e.preventDefault();

				// 対応するjs-history-lead-textを探す（同じdydo_history_lead_wrap内）
				const leadText = btn.closest('.dydo_history_lead_wrap')?.querySelector('.js-history-lead-text');

				if (leadText) {
					// テキストを展開
					leadText.classList.add('is-expanded');
					// ボタンを非表示
					btn.style.display = 'none';

					// コンテンツの高さが変わったので、少し遅延してプログレスバーを再計算
					setTimeout(() => {
						updateProgressBar();
					}, 100);
				}
			});
		});
	};

	// js-history-readmoreの「もっと読む」ボタンの処理
	const initShortTextReadMore = () => {
		const readMoreBtns = document.querySelectorAll('.js-history-readmore-btn');

		readMoreBtns.forEach(btn => {
			btn.addEventListener('click', (e) => {
				e.preventDefault();

				// 対応するjs-history-readmoreを探す
				const shortText = btn.closest('.dydo_history_item, .content-wrapper, .text-container')?.querySelector('.js-history-readmore') ||
					btn.parentElement?.querySelector('.js-history-readmore') ||
					btn.previousElementSibling;

				if (shortText && shortText.classList.contains('js-history-readmore')) {
					// テキストを展開
					shortText.classList.add('is-expanded');
					// ボタンを非表示
					btn.style.display = 'none';

					// コンテンツの高さが変わったので、少し遅延してプログレスバーを再計算
					setTimeout(() => {
						updateProgressBar();
					}, 100);
				}
			});
		});
	};

	// アニメーション停止/再生コントロールの処理
	const initAnimationControl = () => {
		const controlBtn = document.querySelector('.js-historyControl');
		const animationBg = document.querySelector('.dydo_history_head_bg');

		if (!controlBtn || !animationBg) return;

		controlBtn.addEventListener('click', (e) => {
			e.preventDefault();

			// アニメーションの停止/再生を切り替え
			animationBg.classList.toggle('is-pause');

			// アイコンの表示を切り替え
			const playIcon = controlBtn.querySelector('svg:not(.is-active)');
			const stopIcon = controlBtn.querySelector('svg.is-active');

			if (playIcon && stopIcon) {
				playIcon.classList.toggle('is-active');
				stopIcon.classList.toggle('is-active');
			}
		});
	};

	// dydo_history_lead要素のIntersection Observer設定
	const initLeadAnimation = () => {
		const leadElements = document.querySelectorAll('.dydo_history_lead');

		if (!leadElements.length) return;

		const options = {
			root: null,
			rootMargin: '-20% 0px',
			threshold: 0
		};

		const observer = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					// 要素が画面内に入ったらis-activeクラスを付与
					entry.target.classList.add('is-active');
				}
			});
		}, options);

		// 複数の要素をそれぞれ監視
		leadElements.forEach(element => {
			observer.observe(element);
		});
	};

	const updateProgressBar = () => {
		// 現在アクティブなタブコンテンツのセクションのみ取得
		const activeTabContent = document.querySelector('.js-tab-content.is-active.is-visible');
		if (!activeTabContent) return;

		const sections = activeTabContent.querySelectorAll('[id^="tab_"]');
		updateProgressBarForTab(sections, true); // 通常スクロール時はis-activeを更新
		updateScrollLine(); // 垂直ラインの進捗も更新
	};

	// 1024px以下の場合、アクティブなアンカーリンクに横スクロールを合わせる関数
	const autoScrollToActiveAnchor = (anchorLinks, activeIndex) => {
		const scrollContainer = document.querySelector('.dydo_history_anchor_scroll');
		if (!scrollContainer || activeIndex < 0 || activeIndex >= anchorLinks.length) return;

		const activeLink = anchorLinks[activeIndex];
		if (!activeLink) return;

		// スクロールコンテナとアクティブリンクの情報を取得
		const containerRect = scrollContainer.getBoundingClientRect();
		const linkRect = activeLink.getBoundingClientRect();

		// 現在のスクロール位置
		const currentScrollLeft = scrollContainer.scrollLeft;

		// アクティブリンクがコンテナの中央に来るように計算
		const linkCenter = linkRect.left - containerRect.left + currentScrollLeft + linkRect.width / 2;
		const containerCenter = containerRect.width / 2;
		const targetScrollLeft = linkCenter - containerCenter;

		// スムーズスクロールでアクティブリンクの位置に移動
		scrollContainer.scrollTo({
			left: Math.max(0, targetScrollLeft),
			behavior: 'smooth'
		});
	};

	const updateProgressBarForTab = (sections, shouldUpdateActiveLinks = false) => {
		const progressLine = document.querySelector('.__progress .__line');
		const anchorLinks = document.querySelectorAll('.dydo_history_anchor_inner a[href^="#tab_"]');
		const progressContainer = document.querySelector('.__progress');

		if (!sections.length || !progressLine || !anchorLinks.length || !progressContainer) return;

		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

		// 判定位置を設定（ヘッダー + アンカーエリア）
		const isTablet = window.innerWidth <= 768; // メディアクエリの判定
		const headerHeight = isTablet ? 62 : 120; // ヘッダー高さ
		const anchorHeight = isTablet ? 140 : 194; // アンカーエリア高さ（仮の値、実際の値に調整）
		const judgmentPosition = headerHeight + anchorHeight + 5; // 5pxのマージンを追加

		let currentSection = 0;
		let sectionProgress = 0; // セクション内の進捗（0-1）

		// 全体の範囲を算出（最初のセクションから最後のセクションまで）
		const firstSection = sections[0];
		const lastSection = sections[sections.length - 1];
		const firstSectionTop = firstSection.getBoundingClientRect().top + scrollTop;
		const lastSectionTop = lastSection.getBoundingClientRect().top + scrollTop;

		// スクロール位置が最初のセクションより前の場合
		if (scrollTop + judgmentPosition < firstSectionTop) {
			currentSection = 0;
			sectionProgress = 0;
		}
		// スクロール位置が最後のセクション以降の場合
		else if (scrollTop + judgmentPosition >= lastSectionTop) {
			currentSection = sections.length - 1;
			sectionProgress = 1;
		}
		// 各セクション間での判定
		else {
			for (let i = 0; i < sections.length - 1; i++) {
				const currentSectionEl = sections[i];
				const nextSectionEl = sections[i + 1];

				const currentTop = currentSectionEl.getBoundingClientRect().top + scrollTop;
				const nextTop = nextSectionEl.getBoundingClientRect().top + scrollTop;

				if (scrollTop + judgmentPosition >= currentTop && scrollTop + judgmentPosition < nextTop) {
					currentSection = i;
					const sectionDistance = nextTop - currentTop;
					const currentDistance = (scrollTop + judgmentPosition) - currentTop;
					sectionProgress = Math.max(0, Math.min(1, currentDistance / sectionDistance));
					break;
				}
			}
		}

		// プログレスバーの幅を計算
		const progressRect = progressContainer.getBoundingClientRect();
		let progressWidth = 0;

		if (anchorLinks.length > 0) {
			if (currentSection === 0 && sectionProgress === 0) {
				// 最初のセクション開始前でも最初のaタグの位置まで伸ばす
				const firstLink = anchorLinks[0];
				if (firstLink) {
					const firstLinkRect = firstLink.getBoundingClientRect();
					const firstCenter = firstLinkRect.left + firstLinkRect.width / 2;
					const progressLeft = progressRect.left;
					const progressContainerWidth = progressRect.width;
					progressWidth = (firstCenter - progressLeft) / progressContainerWidth * 100;
				}
			} else if (currentSection === anchorLinks.length - 1) {
				// 最後のセクションは100%
				progressWidth = 100;
			} else {
				// 現在と次のaタグ間で補間
				const currentLink = anchorLinks[currentSection];
				const nextLink = anchorLinks[Math.min(currentSection + 1, anchorLinks.length - 1)];

				if (currentLink && nextLink) {
					const currentLinkRect = currentLink.getBoundingClientRect();
					const nextLinkRect = nextLink.getBoundingClientRect();

					const currentCenter = currentLinkRect.left + currentLinkRect.width / 2;
					const nextCenter = nextLinkRect.left + nextLinkRect.width / 2;

					const interpolatedCenter = currentCenter + (nextCenter - currentCenter) * sectionProgress;

					const progressLeft = progressRect.left;
					const progressContainerWidth = progressRect.width;
					progressWidth = (interpolatedCenter - progressLeft) / progressContainerWidth * 100;
				}
			}
		}

		progressLine.style.width = `${Math.max(0, Math.min(progressWidth, 100))}%`;

		// 通常のスクロール時のみis-activeを更新
		if (shouldUpdateActiveLinks) {
			anchorLinks.forEach((link, index) => {
				link.classList.toggle('is-active', index === currentSection);
				// 通過したアンカーリンクにis-throughを付与、それ以外は削除
				if (index < currentSection) {
					link.classList.add('is-through');
				} else {
					link.classList.remove('is-through');
				}
			});

			// 1024px以下の場合、アクティブなアンカーリンクに横スクロールを合わせる
			const isTabletOrBelow = window.innerWidth <= 1024;
			if (isTabletOrBelow) {
				autoScrollToActiveAnchor(anchorLinks, currentSection);
			}
		}
	};

	// 垂直スクロールラインの進捗を更新する関数
	const updateScrollLine = () => {
		const activeTabContent = document.querySelector('.js-tab-content.is-active.is-visible');
		if (!activeTabContent) return;
		
		// アクティブなタブ内のスクロールライン要素を取得
		const scrollLineElement = activeTabContent.querySelector('.js-history-scroll-line');
		if (!scrollLineElement) return;

		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		
		// スクロールライン要素自体の位置とサイズを取得
		const lineRect = scrollLineElement.getBoundingClientRect();
		const lineTopAbsolute = lineRect.top + scrollTop;
		const lineHeight = lineRect.height;

		// 画面の高さの60%の位置（ビューポート基準）
		const viewport60Percent = scrollTop + (window.innerHeight * 0.7);
		
		// スクロールライン上端から画面60%地点までの距離でプログレス計算
		let progress = 0;
		
		if (viewport60Percent >= lineTopAbsolute) {
			// ビューポート60%地点がライン開始位置を超えている場合
			progress = (viewport60Percent - lineTopAbsolute) / lineHeight;
		}
		
		// プログレスを0-100%の範囲に制限
		progress = Math.max(0, Math.min(1, progress));
		
		// CSS変数を使用してAfter擬似要素の高さを更新
		scrollLineElement.style.setProperty('--scroll-progress', `${progress * 100}%`);
	};

	const initScrollHandler = () => {
		// 現在アクティブなタブコンテンツのセクションを取得
		const activeTabContent = document.querySelector('.js-tab-content.is-active.is-visible');
		if (!activeTabContent) return;

		const sections = activeTabContent.querySelectorAll('[id^="tab_"]');
		const progressLine = document.querySelector('.__progress .__line');
		const anchorLinks = document.querySelectorAll('.dydo_history_anchor_inner a[href^="#tab_"]');
		const progressContainer = document.querySelector('.__progress');
		const historyTabs = document.querySelectorAll('.js-history-tab');

		if (!sections.length || !progressLine || !anchorLinks.length || !progressContainer) return;

		// 初期状態を設定
		updateProgressBar();
		updateScrollLine(); // 垂直ラインも初期化

		// 初期状態で1024px以下の場合、アクティブなアンカーリンクに横スクロールを合わせる
		const isTabletOrBelow = window.innerWidth <= 1024;
		if (isTabletOrBelow) {
			const activeIndex = Array.from(anchorLinks).findIndex(link => link.classList.contains('is-active'));
			if (activeIndex !== -1) {
				setTimeout(() => {
					autoScrollToActiveAnchor(anchorLinks, activeIndex);
				}, 100);
			}
		}

		// スクロールイベントリスナーを追加（パフォーマンス考慮でthrottle）
		let ticking = false;
		const handleScroll = () => {
			if (!ticking) {
				requestAnimationFrame(() => {
					updateProgressBar();
					updateScrollLine(); // 垂直ラインも更新
					ticking = false;
				});
				ticking = true;
			}
		};

		window.addEventListener('scroll', handleScroll, { passive: true });

		// リサイズイベント時にアクティブアンカーリンクの位置を調整
		window.addEventListener('resize', () => {
			const isTabletOrBelow = window.innerWidth <= 1024;
			if (isTabletOrBelow) {
				const activeIndex = Array.from(anchorLinks).findIndex(link => link.classList.contains('is-active'));
				if (activeIndex !== -1) {
					setTimeout(() => {
						autoScrollToActiveAnchor(anchorLinks, activeIndex);
					}, 100);
				}
			}
			// リサイズ時もスクロールラインを更新
			updateScrollLine();
		}, { passive: true });

		// アンカーリンククリック時のイベントリスナー
		anchorLinks.forEach(link => {
			link.addEventListener('click', () => {
				// クリックされたリンクに対応するセクションのインデックスを取得
				const href = link.getAttribute('href');
				const targetId = href.substring(1); // "#history01" -> "history01"
				const targetIndex = Array.from(sections).findIndex(section => section.id === targetId);

				if (targetIndex !== -1) {
					// 1024px以下の場合、クリックされたアンカーリンクに横スクロールを合わせる
					const isTabletOrBelow = window.innerWidth <= 1024;
					if (isTabletOrBelow) {
						autoScrollToActiveAnchor(anchorLinks, targetIndex);
					}

					// 少し遅延させて、スクロール完了後に状態を更新
					setTimeout(() => {
						updateProgressBar();
						updateScrollLine(); // 垂直ラインも更新
					}, 100);
				}
			});
		});

		// タブ切り替え時の処理
		historyTabs.forEach(tab => {
			tab.addEventListener('click', (e) => {
				e.preventDefault();
				e.stopPropagation();
				e.stopImmediatePropagation();
				
				const targetContent = tab.getAttribute('data-target');
				
				// 他のJSとの競合を防ぐため、タブボタンからis-visibleを削除
				historyTabs.forEach(t => {
					t.classList.remove('is-visible');
				});
				
				// すでにアクティブなタブがクリックされた場合は何もしない
				if (tab.classList.contains('is-active')) {
					console.log('Tab already active, skipping...');
					
					const targetTabContent = document.querySelector(`.js-tab-content[data-target="${targetContent}"]`);
					if (targetTabContent && !targetTabContent.classList.contains('is-visible')) {
						console.log('Fixing missing is-visible class...');
						targetTabContent.classList.add('is-visible');
					}
					return;
				}
				
				const existingActiveContent = document.querySelector(`.js-tab-content[data-target="${targetContent}"].is-active.is-visible`);
				if (existingActiveContent) {
					console.log('Target content already active, skipping...');
					return;
				}
				
				console.log('Switching to tab:', targetContent);
				const tabNumber = targetContent.replace('tabContent', '');

				// タブボタンのアクティブ状態を更新
				historyTabs.forEach(t => t.classList.remove('is-active'));
				tab.classList.add('is-active');

				// タブコンテンツの表示/非表示を更新
				const allTabContents = document.querySelectorAll('.js-tab-content');
				console.log('Found tab contents:', allTabContents.length);
				allTabContents.forEach((content, index) => {
					console.log(`Removing classes from content ${index}:`, content.getAttribute('data-target'));
					content.classList.remove('is-active', 'is-visible');
				});

				const targetTabContent = document.querySelector(`.js-tab-content[data-target="${targetContent}"]`);
				console.log('Target tab content element:', targetTabContent);
				if (targetTabContent) {
					console.log('Adding classes to target content...');
					targetTabContent.classList.add('is-active', 'is-visible');
					console.log('Target content classes after adding:', targetTabContent.classList.toString());
				} else {
					console.error(`Tab content with data-target="${targetContent}" not found`);
				}

				// アンカーリンクのhrefを更新（即座に実行）
				anchorLinks.forEach((link, index) => {
					const historyNumber = String(index + 1).padStart(2, '0');
					const newHref = `#tab_${tabNumber}history${historyNumber}`;
					link.setAttribute('href', newHref);
					console.log(link, index, newHref);
					// アクティブクラスをリセット
					link.classList.remove('is-active');
				});
				
				// 最初のアンカーリンクをアクティブに
				if (anchorLinks[0]) {
					anchorLinks[0].classList.add('is-active');
				}

				// DOM更新を確実に待つためにrequestAnimationFrameを2回使用
				requestAnimationFrame(() => {
					requestAnimationFrame(() => {
						// 最初のセクションに移動
						const firstSection = document.querySelector(`#tab_${tabNumber}history02`);
						if (firstSection) {
							const headerHeight = window.innerWidth <= 768 ? 62 : 120;
							const anchorHeight = window.innerWidth <= 768 ? 140 : 194;
							const offsetTop = firstSection.getBoundingClientRect().top + window.scrollY - headerHeight - anchorHeight;

							window.scrollTo({
								top: offsetTop,
								behavior: 'smooth'
							});

							// 1024px以下の場合、タブ切り替え時に最初のアンカーリンクに横スクロールを合わせる
							const isTabletOrBelow = window.innerWidth <= 1024;
							if (isTabletOrBelow) {
								setTimeout(() => {
									const updatedAnchorLinks = document.querySelectorAll('.dydo_history_anchor_inner a[href^="#tab_"]');
									autoScrollToActiveAnchor(updatedAnchorLinks, 0);
								}, 300);
							}

							// スクロール完了後にプログレスバーとスクロールラインを更新
							setTimeout(() => {
								updateProgressBar();
								updateScrollLine();
							}, 500);
						}
					});
				});

				// // まずプログレスバーを一旦リセット
				// progressLine.style.width = '0%';
				// 
				// // DOM更新を待ってからプログレスバー再計算を実行
				// setTimeout(() => {
				// 	// 新しいタブのセクションを明示的に指定してプログレスバーを更新
				// 	const newActiveTabContent = document.querySelector(`section.js-tab-content[data-target="${targetContent}"]`);
				// 	
				// 	if (newActiveTabContent) {
				// 		const newSections = newActiveTabContent.querySelectorAll('[id^="tab_"]');
				// 		
				// 		if (newSections.length > 0) {
				// 			// 新しいタブのセクションでプログレスバーを再計算
				// 			updateProgressBarForTab(newSections, false);
				// 			
				// 			// プログレスバーの位置に基づいてis-activeを設定
				// 			setTimeout(() => {
				// 				const progressRect = progressContainer.getBoundingClientRect();
				// 				const progressLineWidth = parseFloat(progressLine.style.width) || 0;
				// 				
				// 				if (progressLineWidth > 0) {
				// 					const currentProgressPosition = progressRect.left + (progressRect.width * progressLineWidth / 100);
				// 					
				// 					let activeIndex = 0;
				// 					
				// 					// 各アンカーリンクの位置とプログレスバーの現在位置を比較
				// 					anchorLinks.forEach((link, index) => {
				// 						const linkRect = link.getBoundingClientRect();
				// 						const linkCenter = linkRect.left + linkRect.width / 2;
				// 						
				// 						// プログレスバーが通過している（左側にある）リンクの中で最も右側のものを選択
				// 						if (currentProgressPosition >= linkCenter) {
				// 							activeIndex = index;
				// 						}
				// 					});
				// 					
				// 					// 対応するアンカーリンクにis-activeを設定
				// 					if (anchorLinks[activeIndex]) {
				// 						anchorLinks[activeIndex].classList.add('is-active');
				// 					}
				// 				} else {
				// 					// プログレスバーが0%の場合は最初のリンクをアクティブに
				// 					if (anchorLinks[0]) {
				// 						anchorLinks[0].classList.add('is-active');
				// 					}
				// 				}
				// 			}, 100);
				// 		}
				// 	}
				// }, 100);
			});
		});
	};

	// モーダルボタンの処理
	const initModalBtn = () => {
		const modalBtns = document.querySelectorAll('.__modalBtn');

		modalBtns.forEach(btn => {
			btn.addEventListener('click', (e) => {
				e.preventDefault();

				// 少し遅延してからモーダルコンテンツの高さを取得
				setTimeout(() => {
					const modalContent = document.querySelector('.mod-modal-overlay .mod-modalContent');
					const modalWrap = document.querySelector('.mod-modal-overlay .dydo_history_modal_wrap');

					if (modalContent && modalWrap) {
						const contentHeight = modalContent.offsetHeight;
						modalWrap.style.height = `${contentHeight}px`;
					}
				}, 10); // モーダルが表示されてから高さを取得
			});
		});
	};

	// タブリンクの処理
	const initTabLink = () => {
		const tabLinks = document.querySelectorAll('.js-tablink');

		tabLinks.forEach(link => {
			link.addEventListener('click', (e) => {
				e.preventDefault();

				const targetHash = link.getAttribute('data-hash');
				if (!targetHash) return;

				// 指定されたIDの要素を検索
				const targetElement = document.getElementById(targetHash);
				if (!targetElement) return;

				// 要素がどのタブコンテンツに属しているか確認
				const tabContent = targetElement.closest('.js-tab-content');
				if (!tabContent) return;

				const targetTabId = tabContent.getAttribute('data-target');
				
				// 対応するタブボタンを取得
				const targetTab = document.querySelector(`.js-history-tab[data-target="${targetTabId}"]`);
				
				// 現在アクティブなタブと異なる場合のみタブ切り替えを実行
				let needsTabSwitch = false;
				if (targetTab && !targetTab.classList.contains('is-active')) {
					needsTabSwitch = true;
					
					// タブボタンのアクティブ状態を更新
					const historyTabs = document.querySelectorAll('.js-history-tab');
					historyTabs.forEach(t => t.classList.remove('is-active'));
					targetTab.classList.add('is-active');

					// タブコンテンツの表示/非表示を更新
					const allTabContents = document.querySelectorAll('.js-tab-content');
					allTabContents.forEach(content => {
						content.classList.remove('is-active', 'is-visible');
					});

					tabContent.classList.add('is-active', 'is-visible');

					// アンカーリンクのhrefを対応するタブ用に更新
					const anchorLinks = document.querySelectorAll('.dydo_history_anchor_inner a[href^="#tab_"]');
					const tabNumber = targetTabId.replace('tabContent', ''); // "01" or "02"
					anchorLinks.forEach((anchorLink, index) => {
						const historyNumber = String(index + 1).padStart(2, '0');
						const newHref = `#tab_${tabNumber}history${historyNumber}`;
						anchorLink.setAttribute('href', newHref);
					});
				}

				// 指定されたIDまでスクロール
				setTimeout(() => {
					const headerHeight = window.innerWidth <= 768 ? 62 : 120;
					const anchorHeight = window.innerWidth <= 768 ? 140 : 194;
					const option = window.innerWidth <= 768 ? 36 : 56;
					const offsetTop = targetElement.getBoundingClientRect().top + window.scrollY - headerHeight - anchorHeight - option;

					window.scrollTo({
						top: offsetTop,
						behavior: 'smooth'
					});

					// スクロール完了後にプログレスバーを更新
					setTimeout(() => {
						updateProgressBar();
						updateScrollLine();
					}, 300);
				}, needsTabSwitch ? 200 : 0); // タブ切り替えがあった場合は遅延
			});
		});
	};

	// ページ読み込み完了後にスクロールハンドラーとリードアニメーションを初期化
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', () => {
			initScrollHandler();
			initLeadAnimation();
			initReadMoreButton();
			initShortTextReadMore();
			initAnimationControl();
			initModalBtn();
			initTabLink();
		});
	} else {
		initScrollHandler();
		initLeadAnimation();
		initReadMoreButton();
		initShortTextReadMore();
		initAnimationControl();
		initModalBtn();
		initTabLink();
	}

	// デバッグ用の関数をwindowオブジェクトに追加
	window.debugHistory = {
		// 現在のアクティブなタブコンテンツを取得
		getActiveTabContent() {
			return document.querySelector('.js-tab-content.is-active.is-visible');
		},
		
		// 現在のアクティブなセクションを取得
		getActiveSections() {
			const activeTabContent = this.getActiveTabContent();
			return activeTabContent ? activeTabContent.querySelectorAll('[id^="tab_"]') : [];
		},
		
		// アンカーリンクの状態を確認
		getAnchorLinks() {
			return document.querySelectorAll('.dydo_history_anchor_inner a[href^="#tab_"]');
		},
		
		// プログレスバーの状態を確認
		getProgressBar() {
			return {
				container: document.querySelector('.__progress'),
				line: document.querySelector('.__progress .__line'),
				width: document.querySelector('.__progress .__line')?.style.width
			};
		},
		
		// 手動でプログレスバー更新をテスト
		testUpdateProgressBar() {
			console.log('Testing updateProgressBar...');
			updateProgressBar();
		},
		
		// 手動でスクロールライン更新をテスト
		testUpdateScrollLine() {
			console.log('Testing updateScrollLine...');
			updateScrollLine();
		},
		
		// タブ切り替えテスト
		switchToTab(tabNumber) {
			console.log(`Switching to tab ${tabNumber}...`);
			const targetTab = document.querySelector(`.js-history-tab[data-target="tabContent${tabNumber}"]`);
			console.log('Target tab element:', targetTab);
			
			if (targetTab) {
				console.log('Tab found, clicking...');
				const isActive = targetTab.classList.contains('is-active');
				console.log('Tab is already active:', isActive);
				
				// クリック前のタブコンテンツの状態
				console.log('Before click - all tab contents:');
				document.querySelectorAll('.js-tab-content').forEach((content, index) => {
					console.log(`Content ${index}:`, content.getAttribute('data-target'), content.classList.toString());
				});
				
				targetTab.click();
				
				// クリック後の状態確認
				setTimeout(() => {
					console.log('After click - tab classes:', targetTab.classList.toString());
					console.log('After click - all tab contents:');
					document.querySelectorAll('.js-tab-content').forEach((content, index) => {
						console.log(`Content ${index}:`, content.getAttribute('data-target'), content.classList.toString());
					});
					console.log('After click - active tab content:', this.getActiveTabContent());
				}, 100);
				
				return true;
			} else {
				console.error(`Tab ${tabNumber} not found`);
				// 利用可能なタブを表示
				const allTabs = document.querySelectorAll('.js-history-tab');
				console.log('Available tabs:');
				allTabs.forEach((tab, index) => {
					console.log(`Tab ${index}:`, tab.getAttribute('data-target'), tab.classList.toString());
				});
				return false;
			}
		},
		
		// タブコンテンツの詳細状態確認
		checkTabContents() {
			console.log('=== Tab Contents Debug ===');
			const allTabContents = document.querySelectorAll('.js-tab-content');
			console.log('Total tab contents found:', allTabContents.length);
			
			allTabContents.forEach((content, index) => {
				console.log(`Tab Content ${index}:`);
				console.log('  - data-target:', content.getAttribute('data-target'));
				console.log('  - classes:', content.classList.toString());
				console.log('  - has is-active:', content.classList.contains('is-active'));
				console.log('  - has is-visible:', content.classList.contains('is-visible'));
				console.log('  - element:', content);
			});
			
			const activeTab = document.querySelector('.js-tab-content.is-active');
			const visibleTab = document.querySelector('.js-tab-content.is-visible');
			const activeVisibleTab = document.querySelector('.js-tab-content.is-active.is-visible');
			
			console.log('Active tab (.is-active):', activeTab);
			console.log('Visible tab (.is-visible):', visibleTab);
			console.log('Active AND visible tab (.is-active.is-visible):', activeVisibleTab);
		},
		
		// 指定IDへのスクロールテスト
		scrollToId(targetId) {
			console.log(`Scrolling to ${targetId}...`);
			const targetElement = document.getElementById(targetId);
			if (targetElement) {
				const headerHeight = window.innerWidth <= 768 ? 62 : 120;
				const anchorHeight = window.innerWidth <= 768 ? 140 : 194;
				const offsetTop = targetElement.getBoundingClientRect().top + window.scrollY - headerHeight - anchorHeight;

				window.scrollTo({
					top: offsetTop,
					behavior: 'smooth'
				});
			} else {
				console.error(`Element with ID ${targetId} not found`);
			}
		},
		
		// js-tablinkのテスト
		testTabLink(targetHash) {
			console.log(`Testing tablink with hash: ${targetHash}`);
			const links = document.querySelectorAll('.js-tablink');
			console.log('Found tablinks:', links.length);
			links.forEach((link, index) => {
				console.log(`Link ${index}:`, link.getAttribute('data-hash'));
			});
			
			// 指定されたhashを持つリンクをクリックシミュレート
			const targetLink = Array.from(links).find(link => link.getAttribute('data-hash') === targetHash);
			if (targetLink) {
				console.log('Clicking target link...');
				targetLink.click();
			} else {
				console.error(`Link with hash ${targetHash} not found`);
			}
		},
		
		// 現在の状態を全て表示
		showCurrentState() {
			console.log('=== History Debug State ===');
			console.log('Active tab content:', this.getActiveTabContent());
			console.log('Active sections:', this.getActiveSections());
			console.log('Anchor links:', this.getAnchorLinks());
			console.log('Progress bar:', this.getProgressBar());
			console.log('Window scroll:', window.scrollY);
			console.log('Window size:', window.innerWidth + 'x' + window.innerHeight);
		}
	};

})(window.FUNCTIONS);
